function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../common/utils/index.js';
import window from '../../common/window/windowWrapper';
import { GalleryComponent } from '../galleryComponent';

var GalleryDebugMessage =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(GalleryDebugMessage, _GalleryComponent);

  function GalleryDebugMessage() {
    return _GalleryComponent.apply(this, arguments) || this;
  }

  var _proto = GalleryDebugMessage.prototype;

  _proto.render = function render() {
    if (utils.getTopUrlParam('pgdebug') !== 'true') {
      return false;
    }

    var version = React.createElement("div", {
      className: "version-header "
    }, "Pro Gallery Version #", window.staticsVersion);
    var parentSize = '';

    try {
      parentSize = ' psw' + window.top.screen.width + ' piw' + window.top.innerWidth + ' pbw' + window.top.document.body.clientWidth;
    } catch (e) {//not on the domain
    }

    var debugMsg = React.createElement("div", {
      className: "version-header "
    }, utils.isLandscape() ? 'land' : 'port', " sw", window.screen.width, "sh", window.screen.height, " iw", window.innerWidth, " bw", window.document.body.clientWidth, " sr", '1', "rc", this.props.resizeCount, " oc", this.props.orientationCount, " nh", this.props.newHeight, " lh", this.props.lastHeight, parentSize, "www", this.props.maxGalleryWidth);
    return React.createElement("div", null, version, debugMsg);
  };

  return GalleryDebugMessage;
}(GalleryComponent);

export default GalleryDebugMessage;